import { MoreHorizontal, Edit2, Trash2, Eye, EyeOff } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { ProductStatus } from '@/hooks/useProducerProducts';

interface ProductActionsMenuProps {
  onEdit: () => void;
  onDelete: () => void;
  onToggleStatus?: () => void;
  status?: ProductStatus;
}

/**
 * Kebab menu for product actions on mobile.
 * Replaces inline icon buttons with a single overflow trigger (44px min target).
 */
export function ProductActionsMenu({ onEdit, onDelete, onToggleStatus, status }: ProductActionsMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="h-11 w-11 shrink-0"
          aria-label="Produktåtgärder"
          onClick={(e) => e.stopPropagation()}
        >
          <MoreHorizontal className="h-5 w-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {onToggleStatus && status && status !== 'archived' && (
          <>
            <DropdownMenuItem onClick={(e) => { e.stopPropagation(); onToggleStatus(); }}>
              {status === 'public' ? (
                <><EyeOff className="h-4 w-4 mr-2" />Avpublicera</>
              ) : (
                <><Eye className="h-4 w-4 mr-2" />Publicera</>
              )}
            </DropdownMenuItem>
            <DropdownMenuSeparator />
          </>
        )}
        <DropdownMenuItem onClick={(e) => { e.stopPropagation(); onEdit(); }}>
          <Edit2 className="h-4 w-4 mr-2" />
          Redigera
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={(e) => { e.stopPropagation(); onDelete(); }}
          className="text-destructive focus:text-destructive"
        >
          <Trash2 className="h-4 w-4 mr-2" />
          Ta bort
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
